module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "side-nav"
  }, _vm._l(((Object.keys(_vm.data))), function(title) {
    return _c('div', [_c('p', {
      staticClass: "side-nav-title"
    }, [_vm._v(_vm._s(title))]), _vm._v(" "), _vm._l((_vm.data[title]), function(nav) {
      return (nav.desc) ? _c('div', {
        staticClass: "side-nav-items"
      }, [(nav.name) ? _c('router-link', {
        class: _vm.$route.name === nav.name ? 'active' : '',
        attrs: {
          "to": {
            name: nav.name
          }
        }
      }, [_vm._v(_vm._s(nav.desc))]) : _c('p', {
        staticClass: "side-nav-group"
      }, [_vm._v(_vm._s(nav.desc))]), _vm._v(" "), _vm._l((nav.items), function(item) {
        return _c('div', [_c('router-link', {
          staticClass: "slid-nav-component",
          class: _vm.$route.name === item.name ? 'active' : '',
          attrs: {
            "to": {
              name: item.name
            }
          }
        }, [_vm._v(_vm._s(item.desc))])], 1)
      })], 2) : _vm._e()
    })], 2)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-10476fbf"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./client/components/side-nav.vue
// module id = 270
// module chunks = 3